import { cssUtil } from "../utils/cssUtil";
import { getBaseStyles } from "./commonStyles";


export function renderSeekWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // Wrapper
    const wrapper = context.document.createElement("div");
    wrapper.classList.add("widget", "seek_widget");
    const breakpoint = context.currentBreakpoint;

    const wrapperStyles = getWrapperStyles(widget, device, breakpoint);
    wrapper.setAttribute("style", cssUtil.toStyleString(wrapperStyles));
    wrapper.setAttribute("data-widgetId", widget.uid);
    wrapper.setAttribute("data-widgetType", widget.type);
    wrapper.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(wrapper);

    // Input
    const input = renderInput(context, widget, device);
    wrapper.appendChild(input);

    // Prompts
    const promptEnabled = device.questionDesign?.bar?.promptEnabled;
    if (promptEnabled) {
        const prompts = renderPrompts(context, widget, device);
        wrapper.appendChild(prompts);
    }

    return wrapper;
}

function renderInput(context, widget, device) {
    const el = context.document.createElement("div");
    el.classList.add("seek_widget__input");

    const placeholder = device.questionDesign?.bar?.placeholderQuestion;
    if (placeholder) {
        el.innerHTML = placeholder;
    }

    const icon = context.document.createElement("i");
    icon.classList.add("cleverstory-paperflite-logo");
    el.appendChild(icon);

    const styles = getInputStyles(widget, device);
    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);
    

    return el;
}

function renderPrompts(context, widget, device) {
    const el = context.document.createElement("div");
    el.classList.add("seek_widget__prompts");

    el.setAttribute(
        "style",
        "text-align:center;margin-top:16px;width:100%;padding:10px"
    );
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    const prompts = device.questionDesign?.bar?.prompts || [];

    prompts.forEach(prompt => {
        if (!prompt) return;

        const item = context.document.createElement("div");
        item.classList.add("prompt_item");

        const styles = getPromptStyles(widget, device);
        item.setAttribute("style", cssUtil.toStyleString(styles));

        item.innerHTML = prompt;
        el.appendChild(item);
    });

    return el;
}

function getWrapperStyles(widget, device, breakpoint) {
    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    styles.padding = `${device.padding}px`;
    styles.height = "auto";
    styles.display = "flex";
    styles["flex-direction"] = "column";
    styles["justify-content"] = "center";
    styles["align-items"] = "center";

    const bg = device.responseDesign?.backgroundColor;
    if (bg && bg.type === "solid") {
        styles["background-color"] = cssUtil.getCssColor(bg);
    }

    return styles;
}

function getInputStyles(widget, device) {
    const styles = {
        ...getBaseStyles(widget)
    };

    const bg = device.questionDesign?.bar?.inputFieldColor;
    if (bg?.type === "solid") {
        styles.background = cssUtil.getCssColor(bg);
    }

    const colorProp = device.font?.tertiaryColor;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }

    applyFontStyles(styles, device.font);
    applyBorderStyles(styles, device.questionDesign?.bar?.border);

    styles.width = "100%";
    styles.display = "flex";
    styles["padding-left"] = "10px";
    styles["padding-right"] = "10px";
    styles["justify-content"] = "space-between";

    return styles;
}

function getPromptStyles(widget, device) {
    const styles = {
        ...getBaseStyles(widget)
    };

    const font = device.font;

    if (font?.fontFamily) {
        styles["font-family"] = font.fontFamily;
    }

    styles["font-size"] = "12px";
    styles.display = "inline";
    styles["margin-right"] = "64px";

    const colorProp = font?.secondaryColor;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }

    return styles;
}

function applyFontStyles(styles, font) {
    if (!font) return;

    if (font.fontFamily) {
        styles["font-family"] = font.fontFamily;
    }

    if (font.fontSize) {
        styles["font-size"] = `${font.fontSize}px`;
    }

    const colorProp = font.tertiaryColor;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }
}

function applyBorderStyles(styles, border) {
    if (!border) return;

    const radius = border.radius;
    if (radius) {
        if (radius.topLeft) styles["border-top-left-radius"] = `${radius.topLeft}px`;
        if (radius.topRight) styles["border-top-right-radius"] = `${radius.topRight}px`;
        if (radius.bottomRight) styles["border-bottom-right-radius"] = `${radius.bottomRight}px`;
        if (radius.bottomLeft) styles["border-bottom-left-radius"] = `${radius.bottomLeft}px`;
    }

    const colorProp = border.color;
    if (colorProp) {
        if (colorProp.type === "gradient") {
            styles["border-image"] = cssUtil.getCssGradient(colorProp);
        } else {
            styles["border-color"] = cssUtil.getCssColor(colorProp);
        }
    }

    const width = border.width;
    let borderWidth = parseInt(width || 0, 10);

    if (width) {
        if (border.style === "all") {
            styles["border-width"] = `${width}px`;
            borderWidth *= 2;
        } else {
            styles["border-bottom-width"] = `${width}px`;
            styles["border-bottom-style"] = 'solid';
        }
    }

    const lineHeight = 37 - borderWidth;
    styles["line-height"] = `${lineHeight}px`;
}
